var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "like-dislike" }, [
    _c(
      "div",
      { staticClass: "row row-center" },
      [
        _c(
          "div",
          {
            staticClass: "bottom-button button-like row",
            style: {
              "background-color": _vm.mColor(10),
              color: _vm.item.vote_info == 1 ? _vm.mColor(4) : _vm.mColor(3)
            },
            on: {
              click: function($event) {
                return _vm.vote(1)
              }
            }
          },
          [
            _c("sui-icon", {
              staticClass: "ig--icon",
              attrs: {
                fill: _vm.item.vote_info == 1 ? _vm.mColor(4) : _vm.mColor(2.1),
                name: "arrow-dropup"
              }
            }),
            _c("div", { staticClass: "like-text no-flex" }, [_vm._v("赞同")]),
            _c("div", {
              staticClass: "like-num no-flex",
              domProps: { textContent: _vm._s(_vm.item.approval_num) }
            })
          ],
          1
        ),
        _c(
          "div",
          {
            staticClass: "bottom-button button-dislike",
            style: {
              background: _vm.mColor(10),
              color: _vm.item.vote_info == 1 ? _vm.mColor(4) : _vm.mColor(3)
            },
            on: {
              click: function($event) {
                return _vm.vote(2)
              }
            }
          },
          [
            _c("sui-icon", {
              staticClass: "ig--icon",
              attrs: {
                fill: _vm.item.vote_info == 2 ? _vm.mColor(4) : _vm.mColor(2.1),
                name: "arrow-dropdown"
              }
            })
          ],
          1
        ),
        _vm._t("default")
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }